<template>
  <div id="Dynamic">
    <Head />
    <div class="main">
      <div class="position">
        <img src="../../assets/public/8.png" /> 当前位置:
        <router-link to="/">首页</router-link>>
        <router-link to="/#biaogan">标杆企业</router-link>>企业动态
      </div>
      <h3>企业动态</h3>
      <div class="container">
        <div class="left-box">
          <div class="title">
            <img src="../../assets/Index/s2.png" alt />企业动态
          </div>
          <ul>
            <li :class="{active : navI == 0}" @click="getNav(0)">山东能源集团有限公司</li>
            <li :class="{active : navI == 1}" @click="getNav(1)">义马煤业集团股份有限公司</li>
          </ul>
        </div>
        <div class="right-box">
          <ul>
            <li v-for="(item,index) in list[navI] " :key="index" @click="toDel(0,navI,index)">
              <img :src="item.src" alt />
              <div class="rightContainer">
                <p class="title">{{item.Title | sLen}}</p>
                <p class="container">{{item.content | maxLen}}</p>
                <p class="date">{{item.Date}}</p>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <Foot />
  </div>
</template>

<script>
import Head from "../../components/Head";
import Foot from "../../components/Foot";
export default {
  name: "Dynamic",
  components: {
    Head,
    Foot
  },
  data() {
    return {
      navI: 0,
      list: [
        [
          {
            Title: "山能淄矿亭南煤业：暖心苹果免费领",
            src: require("../../assets/Index/xinwen1.jpg"),
            content:
              "3月22日，山东能源淄矿集团亭南煤业公司工会为缓解长期封闭管理下的职工心理压力，满足职工合理生活诉求，购买了18吨新鲜苹果免费发放给员工。图为结算中心员工王抱龙领取苹果。",
            Date: "2020-03-25"
          },
          {
            Title: "山能龙矿梁家煤矿开展全员大练兵",
            src: require("../../assets/Index/xinwen2.jpg"),
            content:
              "为全面提升职工队伍整体素质，3月下旬，山东能源龙矿集团梁家煤矿全面开展“强‘三基’、提技能”全员大练兵活动，对41项竞赛项目逐一细化分解，实行“清单化+项目化+责任化”管理模式，积极为广大职工提升技能、切磋技艺、展现风采搭建平台。图为电焊工岗位练兵。",
            Date: "2020-03-25"
          },
          {
            Title: "抓时间、抢进度，擂响项目推进战鼓",
            src: require("../../assets/Index/xinwen3.jpg"),
            content:
              "为全面提升职工队伍整体素质，3月下旬，山东能源龙矿集团梁家煤矿全面开展“强‘三基’、提技能”全员大练兵活动，对41项竞赛项目逐一细化分解，实行“清单化+项目化+责任化”管理模式，积极为广大职工提升技能、切磋技艺、展现风采搭建平台。图为电焊工岗位练兵。山能置业德圣公司巨山花园项目以奔跑的干劲、决战的姿态、冲刺的速度，按照“防疫不松劲，复工加把劲”的原则，在做好疫情防控工作的前提下吹响了复工复产的号角，防疫生产“两手抓”，奋力夺取“双胜利”，在二期施工现场掀起了一阵阵施工热潮。图为德圣公司巨山花园项目二期施工现场。",
            Date: "2020-03-25"
          },
          {
            Title: "关键时刻显担当 山能矿工逆行火场驰援地方",
            src: require("../../assets/Index/xinwen4.jpg"),
            content:
              "为全面提升职工队伍整体素质，3月下旬，山东能源龙矿集团梁家煤矿全面开展“强‘三基’、提技能”全员大练兵活动，对41项竞赛项目逐一细化分解，实行“清单化+项目化+3月19日下午16时，山东能源龙矿集团大恒煤业突然接到山西省朔州市平鲁区下面高乡政府的救援通知，位于矿区下面高乡白家梁村旧址突发山火，请求援助。该煤业公司立刻调动了7辆车辆，60余名矿工奔赴火场。经过奋战，晚上20时，山火成功被扑灭。该公司关键时刻的紧急驰援，得到了驻地政府和百姓的高度赞扬，彰显了国企的责任担当。",
            Date: "2020-03-20"
          },
          {
            Title: "山能龙矿梁家煤矿充填试采钻孔项目顺利开工",
            src: require("../../assets/Index/xinwen5.jpg"),
            content:
              "3月17日上午，随着钻机的一阵阵轰鸣声，山东能源龙矿集团梁家煤矿充填试采地面系统钻孔项目顺利开工。启动标志着，该矿充填试采工程地面系统建设进入实质性施工阶段，为矿井找煤扩量、延续生存迈出了关键一步。",
            Date: "2020-03-18"
          },
          {
            Title: "智能测温提升职工入井速度",
            src: require("../../assets/Index/xinwen6.jpg"),
            content:
              "近日，山东能源淄矿集团新河矿业公司副井口投入使用的红外线测温仪，成为严把井口测温关的致胜“法宝”。据了解，该仪器能够实时精准测量下井人员体温，实现人员不停留、不漏检，大大提升了职工入井速度。图为工作人员查看入井人员信息。",
            Date: "2020-03-17"
          }
        ],
        [
          {
            Title: "“点对点”体检电网确保“零接触”",
            src: require("../../assets/Index/xinwen7.jpg"),
            content:
              "3月中旬，针对一年一度的电网春检工作，山东能源龙矿集团供电部实行“点对点”式检修工作制度，并在每个职工作业地点设置隔离护栏，旨在确保“零接触、零交叉、零感染”。此外，还制定了重要用户应急处置预案，以确保检修、保供万无一失。图为：3月13日，龙矿供电部检修人员正在“把脉”设备。",
            Date: "2020-03-16"
          },
          {
            Title: "为矿山添一抹绿色",
            src: require("../../assets/Index/xinwen8.jpg"),
            content:
              "3月12日，山能淄矿邵寨煤业公司开展了“呵护一片绿色”义务植树护绿活动，该公司团委组织广大团员青年对矿区宿舍楼前的花草、树木进行了浇水培土。活动中，他们共浇树30余棵，补种各类绿植22棵。",
            Date: "2020-03-13"
          },
          {
            Title: "山能临矿株柏煤矿：开展“战疫情，绿动青春”志愿植树活动",
            src: require("../../assets/Index/xinwen9.jpg"),
            content:
              "3月12日，山东能源临矿集团株柏煤矿组织各部门青年志愿者开展了“战疫情，绿动青春”活动，分批次、分区域对矿区树木进行了修建、加固，为改善生态环境、建设绿色矿山献出自己的一份力量。",
            Date: "2020-03-12"
          },
          {
            Title: "同栽一片绿 共享一片蓝",
            src: require("../../assets/Index/xinwen10.jpg"),
            content:
              "山东能源枣矿集团铁运处把握好植树节有利时机，提前制定栽种绿化方案，重点对尹洼、孙岗站区进行补种美化，栽植樱花、石楠、红豆杉、女贞、红枫、冬青球等200余株、黄杨400余米4000余棵，绿化面积近2000平方米，勾勒出四季常青、移步异景的温馨生态画卷。",
            Date: "2020-03-12"
          },
          {
            Title: "矿区处处绿意浓",
            src: require("../../assets/Index/xinwen11.jpg"),
            content:
              "3月11日，山东能源淄矿集团亭南煤业公司团委组织开展了“守护绿水青山共建亭煤家园”植树活动，11名青年志愿者为中塬风井栽植补种国槐、松树50余棵。",
            Date: "2020-03-11"
          },
          {
            Title: "手指操为职工思想卸压",
            src: require("../../assets/Index/xinwen12.jpg"),
            content:
              "进入3月份，山东能源淄矿集团新河矿业公司女工委组织协管员利用基层工区班前会时间，带领职工学练“手指操”，让职工利用工作之余解压，及时调整思想状态，消除在疫情防控期间出现的“厌战”情绪。图为3月5日准备工区职工跟随音乐伴奏学练手指操。",
            Date: "2020-03-10"
          }
        ]
      ]
    };
  },
  methods: {
    getNav(i) {
      console.log(i);
      this.navI = i;
    },
    toDel(id,i,j){
        let routeUrl = this.$router.resolve({
        path: "/Notice/NotDel",
        // query: { url:url }
        query: { id: id,xiabiao:i, news: j }
      });
      window.open(routeUrl.href, "_blank");
    }
  },
  filters: {
    sLen(val) {
      if (val.length > 30) {
        val = val.slice(0, 25) + "...";
      }
      return val;
    },
    maxLen(val) {
      if (val.length > 60) {
        val = val.slice(0, 55) + "...";
        return val;
      }
    }
  }
};
</script>

<style lang="less" scope>
#Dynamic {
  font-size: 0.16rem;
  width: 100%;
  min-width: 1000px;
  .main {
    padding: 0 1.35rem;
    margin-top: 0.4rem;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #282828;
    .container {
      display: flex;
      justify-content: space-between;
      .left-box {
        width: 3.5rem;
        border: 0.01rem solid #ababab;

        margin-bottom: 0.3rem;
        height: 2.8rem;
        .title {
          font-size: 0.2rem;
          width: 100%;
          height: 0.64rem;
          padding: 0.17rem 0.21rem;
          background: #3f6bc2;
          color: #fff;
          line-height: 0.64rem;
          display: flex;
          align-items: center;
          img {
            width: 0.3rem;
            height: 0.3rem;
            margin-right: 0.2rem;
          }
        }
        > ul {
          margin-top: 0.05rem;
          .active {
            background: #84c7fa;
            color: #fff;
          }
          > li {
            border-top: 1px solid #bababa;
            padding: 0.17rem;
            cursor: pointer;
          }
          > :first-child {
            border-top: 0;
          }
          > li:last-child {
            border-bottom: 0.01rem solid #ababab;
            margin-bottom: 1rem;
          }
        }
      }
      .right-box {
        width: 12.41rem;
        padding: 0.38rem 0.34rem 0 0.28rem;
        border: 0.01rem solid #ababab;

        ul {
          display: flex;
          width: 100%;
          justify-content: space-between;
          flex-wrap: wrap;
          li {
            cursor: pointer;
            display: flex;
            // justify-content: space-between;
            width: 48%;
            margin-bottom: 0.4rem;
            img {
              width: 50%;
              height: 2.3rem;
            }
            .rightContainer {
              position: relative;
              margin-left: 0.2rem;
              .title {
                // width: 100%;
                // text-align: center;
                // font-weight: 700;
                color: #2e2e2e;
                font-size: 0.18rem;
              }
              .container {
                color: #676767;
                font-size: 0.14rem;
                padding: 0.15rem 0;
              }
              .date {
                color: #676767;
                font-size: 0.14rem;
                position: absolute;
                bottom: 0.1rem;
                right: 0.1rem;
              }
            }
          }
        }
      }
    }
    h3 {
      margin-bottom: 0.5rem;
      padding-top: 0.52rem;
      padding-left: 4rem;
      font-size: 0.3rem;
      text-align: center;
    }
    .position {
      display: flex;
      align-items: center;
      padding: 0.1rem;
      background: #f1f1f1;
      color: #2f4f73;
      img {
        width: 0.2rem;
        margin-right: 0.1rem;
      }
    }
  }
}
</style>